export default {"src":"/_next/static/media/Calendar-blue.6ad13262.svg","height":1600,"width":1600};